import { render, staticRenderFns } from "./TrumbowygEditor.vue?vue&type=template&id=774bcb3e"
import script from "./TrumbowygEditor.vue?vue&type=script&lang=js"
export * from "./TrumbowygEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports